import { useState, useContext, useEffect } from "react"
import Modal from "."
import VerifyOtp from "../_Login/VerifyOtp"
import useService from "../../hooks/useService"
import { sendOtpForCustomer as sendOtpService, verifyOtpForCustomer as verifyOtpService, verifyOtpForUpdateMobile as verifyOTPForUpdateMobileService } from "../../services/Customer";
import { NotificationContext } from "../../contexts/NotificationContext";
import { Box, Button, TextField, Typography } from "@mui/material";
import { CustomerContext } from "../../contexts/CustomerContext";
import { emailRegex } from "../forms/DynamicFormNew";

const ConfirmPhoneModal = (props: { open: boolean, onClose: () => any, onConfirm: () => any, customerRefNo?:string, phoneNumber?: string, floatRight?: boolean }) => {
    const { onClose, open, onConfirm, customerRefNo, phoneNumber, floatRight } = props
    const [validityTime, setValidityTime] = useState(30000);
    const [resendOtpReqCount, setResendOtpReqCount] = useState(1);
    const [isResendOtp, setIsResendOtp] = useState(false);
    const [showVerify, setShowVerify] = useState(false);
    const { execute } = useService()
    const { notify } = useContext(NotificationContext)
    const { setCustomerConfig } = useContext(CustomerContext)
    const [error, setError] = useState('')
    const [phone, setPhone] = useState(phoneNumber || '')
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')

    useEffect(() => {
        if (phoneNumber) {
            setPhone(phoneNumber);
        }
    }, [phoneNumber]);

    const onValidityExpire = () => {
        console.log('onValidityExpire...')
        setIsResendOtp(true);
        setValidityTime(resendOtpReqCount >= 3 ? 180000 : 30000);//set timer of 1 min upto 3 count else timer of 3 min
        setResendOtpReqCount(resendOtpReqCount + 1);//increment count on request of calling function
        if (resendOtpReqCount == 5) setIsResendOtp(false);
    }

    const sendOtp = (mobileNumber: string, email: string) => {
        return execute(() => sendOtpService({mobileNumber, email}));
    }

    const verifyOtp = async (phone: string, otp: string) => {
        const res = await execute(() => verifyOtpService({ otp, phone }));
        if (res.error === null) {
            notify('Mobile Number verified.')
            onConfirm()
        }
        return res
    }

    const verifyOtpForUpdateMobile = async (mobileNumber: string, otp: string) => {
        const res = await execute(() => verifyOTPForUpdateMobileService({ otp, mobileNumber, customerRefNo:customerRefNo! }));
        if (res.error === null) {
            notify('Mobile Number updated.')
            onConfirm()
        }
        return res
    }
    

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhone(e.target.value.replace(/[^0-9]/g, ''))
        if (e.target.value.length === 10) setError('')
        else setError('Invalid Input')
    }

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const sendOtpHandler = async () => {
        if (phone.length !== 10) return notify('Invalid Mobile Number!', 'error')
        if (email && !emailRegex.test(email)) return notify('Invalid email', 'error')

        const { error } = await sendOtp(phone, email)

        if (error === null) {
            setShowVerify(true)
            notify('OTP Sent.')
            setIsResendOtp(false)
            setValidityTime(resendOtpReqCount >= 3 ? 180000 : 30000);
        }
    }

    const closeHandler = () => {
        setPhone('')
        setError('')
        setValidityTime(0)
        setResendOtpReqCount(0)
        setIsResendOtp(false)
        setShowVerify(false)
        onClose()
        setEmail('')
        setEmailError('')
    }

    return <Modal onClose={closeHandler} open={open} title="Verify Mobile Number" floatRight={floatRight}>
        {
            !showVerify ?
                <Box>
                    <Box
                        component="div"
                        sx={{
                            '& .MuiTextField-root': { m: 3, width: '400px' },
                        }}
                    >
                        <div>
                            <TextField
                                required
                                type='number'
                                id="outlined-error-helper-text"
                                label="Mobile Number"
                                onChange={handleChange}
                                error={Boolean(error)}
                                helperText={error}
                                value={phone}
                                fullWidth
                                onKeyDown={(e) => {
                                    if (e && e.key && e.key === "Enter") {
                                        sendOtpHandler();
                                    }
                                }}
                            />
                        </div>
                    </Box>
                                
                    <Box
                        component="div"
                        sx={{
                            '& .MuiTextField-root': { m: 3, width: '400px' },
                        }}
                    >
                        <div>
                            <TextField
                                type='string'
                                id="outlined-error-helper-text"
                                label="Email"
                                onChange={handleEmailChange}
                                error={Boolean(emailError)}
                                helperText={emailError}
                                value={email}
                                fullWidth
                                onKeyDown={(e) => {
                                    if (e && e.key && e.key === "Enter") {
                                        sendOtpHandler();
                                    }
                                }}
                            />
                        </div>
                    </Box>
                    <Typography variant="caption" display="block" marginLeft="25px" marginTop="-15px" marginBottom="20px">
                        {'Note: Please provide email address to get OTP, if user is not registered.'}
                    </Typography>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button variant='contained' disabled={!phone} onClick={() => sendOtpHandler()}>Send OTP</Button>
                    </div>
                </Box> :
                <VerifyOtp
                    isResendOtp={isResendOtp}
                    onValidityExpire={onValidityExpire}
                    phone={phone}
                    email={email}
                    setIsResendOtp={setIsResendOtp}
                    validityTime={validityTime}
                    verifyOTPService={(phone, otp) => customerRefNo ? verifyOtpForUpdateMobile(phone, otp) : verifyOtp(phone, otp)}
                    sendOTPService={sendOtp}
                />}
    </Modal>
}

export default ConfirmPhoneModal